/* unplugin-vue-components disabled */import { render } from "./old.vue?vue&type=template&id=8a8a911a&scoped=true"
import script from "./old.vue?vue&type=script&lang=js"
export * from "./old.vue?vue&type=script&lang=js"

import "./old.vue?vue&type=style&index=0&id=8a8a911a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8a911a"]])

export default __exports__